import { isNotNullOrUndefined } from '../../array';
import { EMPTY_DASH, MIDDLE_DASH } from '../../constants';

export const getLeftAndRightRange = (left: string | number | undefined, right: string | number | undefined) => {
    // Есть оба значения
    if (isNotNullOrUndefined(left) && isNotNullOrUndefined(right)) {
        if (
            typeof left === 'number' &&
            typeof right === 'number' &&
            (!Number.isFinite(left) || !Number.isFinite(right))
        ) {
            return EMPTY_DASH;
        }

        // При этом они равны — возвращаем любое из них
        if (left === right) {
            return left;
        }

        // Иначе возвращаем комбинацию из обоих значений
        return left + MIDDLE_DASH + right;
    }

    // Иначе возвращаем только то значение, которое заполнено
    if (isNotNullOrUndefined(left)) {
        return left;
    }

    // Иначе возвращаем только то значение, которое заполнено
    if (isNotNullOrUndefined(right)) {
        return right;
    }

    return;
};
